<template>
    <div>
        <el-drawer
            :visible.sync="showModal"
            append-to-body
            direction="btt"
            @closed="resetForm"
            size="65%"
            :style="{
                maxWidth: '500px',
                left: '50%',
                transform: 'translateX(-50%)',
            }"
        >
            <template slot="title" class="mb-0">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag type="warning">
                        <i class="el-icon-edit-outline"></i>
                    </el-tag>
                    <h5 class="font-weight-semibold mb-0">Alterar Senha</h5>
                </div>
            </template>

            <div class="px-4 pb-3 d-flex flex-grow-1 flex-column justify-content-between">
                <div class="bg-white border rounded-lg p-2 d-flex align-items-center mb-3">
                    <div class="bg-light border rounded p-2 mr-2" aria-hidden="true">
                        <i class="fas fa-user-lock"></i>
                    </div>
    
                    <div>
                        <h6 class="mb-0 font-weight-bold">Defina uma nova senha</h6>
                        <small> Use pelo menos <strong>8 caracteres</strong>, com <strong>letra</strong> e <strong>número</strong>.</small>
                    </div>
                </div>
    
                <el-form 
                    :model="payload" 
                    ref="changePasswordForm" 
                    label-position="top" 
                    status-icon 
                    :rules="rules"
                > 
                    <el-row :gutter="12">
                        <!-- Senha -->
                        <el-col>
                            <el-form-item prop="senha">
                                <label>Nova senha</label>
                                <el-input
                                    type="password"
                                    v-model="payload.senha" 
                                    placeholder="Digite a nova senha"
                                    :disabled="isLoading"
                                    autocomplete="distribuidor_off"
                                    show-password
                                />
                            </el-form-item>
                        </el-col>
    
                        <!-- Confirmar Senha -->
                        <el-col>
                            <el-form-item prop="senha_confirmation">
                                <label>Confirmar senha</label>
                                <el-input
                                    type="password"
                                    v-model="payload.senha_confirmation" 
                                    placeholder="Confirme a nova senha"
                                    :disabled="isLoading"
                                    autocomplete="distribuidor_off"
                                    show-password
                                />
                            </el-form-item>
                        </el-col>
    
                        <!-- Actions -->
                         <el-col>
                            <div class="d-flex align-items-center justify-content-end">
                                <el-form-item>
                                    <el-button 
                                        type="danger"
                                        plain
                                        :disabled="isLoading"
                                        @click="toggleModal"
                                    >
                                        Cancelar
                                    </el-button>
        
                                    <el-button 
                                        type="primary"
                                        plain
                                        :disabled="isLoading"
                                        @click="onSubmit"
                                    >
                                        <i v-if="isLoading" class="el-icon-loading"></i>
                                        <i class="fas fa-check-circle"></i>
                                        Alterar senha
                                    </el-button>
                                </el-form-item>
                            </div>
                         </el-col>
                    </el-row>
                </el-form>
    
                <div class="bg-white border rounded-lg p-2 d-flex align-items-center mb-3">
                    <div class="bg-light border rounded p-2 mr-2" aria-hidden="true">
                        <i class="el-icon-warning-outline"></i> 
                    </div>
                    <small>A senha será alterada imediatamente, e o usuário precisará usar a nova senha para acessar o sistema.</small>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Card,
        Empty,
        Notification,
        Form, 
        FormItem,
        Drawer,
    } from "element-ui";

    // Api
    import { DistribuidorApi } from "@/api/DistribuidorApi.js";
    const distribuidorApi = new DistribuidorApi();

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                const rules = [
                    { test: /.{8,}/, message: "A senha deve ter pelo menos 8 caracteres." },
                    { test: /[A-Za-z]/, message: "A senha deve ter pelo menos uma letra." },
                    { test: /[0-9]/, message: "A senha deve ter pelo menos um número." }
                ];
                
                for (const rule of rules) {
                    if (!rule.test.test(this.payload.senha)) {
                        callback(new Error(rule.message));
                    }
                }
                callback();
            };

            var validateMatchPass = (rule, value, callback) => {
                 if (value !== this.payload.senha) {
                    callback(new Error('As senhas não se coicidem!'));
                } 

                callback();
            };

            return {
                id: null,
                distributor: null,
                payload: {
                    senha: '',
                    senha_confirmation: '',
                    user_id: null,
                    reset_password: false,
                },
                rules: {
                    senha: [
                        { required: true, message: 'Por favor digite a nova senha' },
                        { validator: validatePass, trigger: 'blur' },
                    ],
                    senha_confirmation: [
                        { required: true, message: 'Por favor digite a senha novamente' },
                        { validator: validateMatchPass, trigger: 'blur' },
                    ],
                },
                showModal: false,
                isLoading: false,
            }
        },
        methods: {
            async show() {
                this.isLoading = true
                
                try {
                    const res = await distribuidorApi.show(this.id);

                    this.distributor = res
                } catch (error) {
                    console.error(error)
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o distribuidor. Algo inesperado ocorreu!'
                    })
                } finally {
                    this.isLoading = false
                }
            },
            async onSubmit() {
                this.$refs.changePasswordForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;

                    try {
                        await distribuidorApi.changePassword(this.payload);
                        
                        Notification.success({
                            title: 'Sucesso',
                            message: 'A Senha foi alterada com sucesso!'
                        });
                    } catch (err) {
                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível alterar a senha!'
                        });
                            
                        console.log(error);
                    } finally {
                        this.isLoading = false;
                        this.toggleModal();
                        this.resetForm();
                    }
                });
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.changePasswordForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.changePasswordForm.resetFields();
            }
        },
        watch: {
            distributor: {
                handler(_newValue) {
                    this.$set(this.payload, 'user_id', _newValue.user_id);
                }
            }
        },
        components: {
            [Message.name]: Message,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Dialog.name]: Dialog,
            [Card.name]: Card,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Drawer.name]: Drawer,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/distribuidor/DistribuidorChangePassword.vue